import React from 'react';
import { ASSET_IMAGES } from 'app/utils/constants/paths';

const ImageOrBlank = ({src, size, style}) => {
    return (
        <img src={ src ? src : `${ASSET_IMAGES}/no-image${size ?? size}.png` } style={style} />
    )
}

export default ImageOrBlank;